import styled from 'styled-components';

import FlexColumn from '@ui/atoms/FlexColumn';

import theme from '@theme/FolxTheme';

export const DashboardCardLayout = styled(FlexColumn)`
	gap: ${theme.spacing.lg};
	max-width: 64rem;
	width: 100%;
`;
